// extracted by mini-css-extract-plugin
export var distribution = "SongTemplate-module--distribution--pg4se";
export var distributor = "SongTemplate-module--distributor--jQ+30";
export var distributors = "SongTemplate-module--distributors--oh5cf";
export var primary = "SongTemplate-module--primary--2oi0X";
export var releases = "SongTemplate-module--releases--uwMto";
export var secondary = "SongTemplate-module--secondary--jNd1U";
export var wrapper = "SongTemplate-module--wrapper--WQk9y";